var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.875C10.3452 4.875 10.625 5.15482 10.625 5.5V9.875H15C15.3452 9.875 15.625 10.1548 15.625 10.5C15.625 10.8452 15.3452 11.125 15 11.125H10.625V15.5C10.625 15.8452 10.3452 16.125 10 16.125C9.65482 16.125 9.375 15.8452 9.375 15.5V11.125H5C4.65482 11.125 4.375 10.8452 4.375 10.5C4.375 10.1548 4.65482 9.875 5 9.875H9.375V5.5C9.375 5.15482 9.65482 4.875 10 4.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.525c0d28c5301c8161962def5a37f23b.svg";
export { ForwardRef as ReactComponent };